import React from "react";
import Axios from 'axios';
import { SketchPicker } from 'react-color';

import GetAuthHeader from '../../../components/Util/GetAuthHeader';
import GetToken from '../../../components/Util/GetToken';
import TransformTitle from '../../../components/Util/TransformTitle';

import {
  Container,
  Row,
  Form,
  Input,
  Label,
  Button,
  Col,
  Card,
  CardBody,
  CardHeader,
  Table,
  FormGroup,
  Modal,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Alert
} from "reactstrap";

import AdminHeader from "components/AdminHeader.jsx";
import Loader from "components/Loader.jsx";
import Preview from "components/Preview.jsx";

class Detail extends React.Component {
  constructor(props) {
    super(props);

    this.unmounted = false;

    this.state = {
      'loading': true,
      'messagesLoading': true,
      'addNew': false,
      'addNewError': false,
      'widgetInfo': {},
      'feeds': [],
      'feedInput': [{
        'title': 'none',
        'feed': 'none'
      }],
      'colors': {
        'background_color': {
          'value': '',
          'label': 'Kleur achtergrond'
        },
        'border_color': {
          'value': '',
          'label': 'Kleur rand'
        },
        'date_color': {
          'value': '',
          'label': 'Kleur datum'
        },
        'label_background_color': {
          'value': '',
          'label': 'Kleur achtergrond button/label'
        },
        'label_text_color': {
          'value': '',
          'label': 'Kleur tekst button/label'
        },
        'title_color': {
          'value': '',
          'label': 'Kleur titel'
        },
        'decription_color': {
          'value': '',
          'label': 'Kleur beschrijving'
        }
      },
      'activePicker': '',
      'exportModal': false,
      'exportCode': '',
      'amount': 0,
      'amountError': false,
      'hideText': false,
      'showTitle': false,
      'messages': [],
      'hidden': [],
      'sticky': [],
      'unsavedChanges': false,
      'enabled': true,
      'title': '',
      'titleError': false
    }
  }

  componentWillMount() {
      document.body.classList.remove('bg-red');
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  componentDidMount() {
    const id = this.props.match.params.id;

    this.refs.previewWidget.runWidgetPreview();

    this.setState({
      'loading': true
    });

    if(GetToken()) {
      Axios.post(this.props.generic.endpoint + 'wp-json/jwt-auth/v1/token/validate', {}, {
        'headers': GetAuthHeader()
      })
        .then( response => {
          if(this.unmounted) return;  

          this.getFeeds.bind(this)();

          this.setState({
            'addNew': (id === 'new')
          }, () => {
            if(!this.state.addNew) {
              this.getWidget.bind(this)(id, false);
            } else {
              this.setState({
                'loading': false
              })
            }
          })
        })
        .catch( error => {
          this.setState({
            'loading': false
          }, () => {
            this.props.history.push('/auth/login');
          })
        });
    } else {
      setTimeout(() => {
        this.setState({
          'loading': false
        }, () => {
          this.props.history.push('/auth/login');
        })
      }, 1000);
    }
  }

  addWidget(e) {
    e.preventDefault();

    const name = e.target.elements.widgetname.value;

    if(name === null || name === undefined || name.length < 1) {
      this.setState({
        'addNewError': 'Kies een naam voor de nieuw aan te maken widget.'
      });

      return false;
    }

    if(name.length < 5) {
      this.setState({
        'addNewError': 'Kies een naam langer dan 5 karakters.'
      });

      return false;
    }

    this.setState({
      'loading': true
    });

    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/add-widget', {
      'name': name
    }, {
      'headers': GetAuthHeader()
    })
      .then( response => {
        if(this.unmounted) return;  

        this.setState({
          'addNew': false
        }, () => {
          this.getWidget.bind(this)(response.data.data.ID, true);
        });

      })
      .catch( error => {
        this.setState({
          'loading': false
        })
      });
  }

  getWidget(id, redirect) {
    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/get-widget', {
      'ID': id
    }, {
      'headers': GetAuthHeader()
    })
      .then( response => {
        if(this.unmounted) return;

        this.setState({
          'widgetInfo': response.data.data
        }, () => {
          this.processFeeds(false);
          this.processColors();

          this.setState({
            'hideText': response.data.data.acf.hide_item_description,
            'showTitle': response.data.data.acf.show_title,
            'amount': response.data.data.acf.maximum_item_count,
            'enabled': response.data.data.acf.widget_enabled === 'y',
            'title': response.data.data.title
          });

          setTimeout(() => {
            this.setState({
              'loading': false
            }, () => {
              if(redirect) {
                this.props.history.push(`/admin/detail/${response.data.data.post.ID}`);
              }
            });
          }, 500);
        });

      })
      .catch( error => {
        this.setState({
          'loading': false
        })
      });
  }

  processFeeds(returnArray) {
    const overview = this.state.widgetInfo.acf.feeds;

    if(overview !== undefined && overview !== null && overview !== false) {
      const feedData = overview.map((item) => {

        return {
          'title': item.feed_title,
          'feed':  item.feed_name
        };
      });

      feedData.push({
          'title': 'none',
          'feed': 'none'
      });

      if(returnArray) {
        return feedData;
      }

      this.setState({
        'feedInput': feedData
      }, () => {
        this.getMessages.bind(this, this.state.feedInput)();
      });
    } else if(this.state.feedInput.length < 2) {
      this.setState({
        'messagesLoading': false
      });
    }
  }

  processColors() {
    const currentState = this.state.colors;

    const colors = {
      'background_color': this.state.widgetInfo.acf.background_color,
      'border_color': this.state.widgetInfo.acf.border_color,
      'date_color': this.state.widgetInfo.acf.date_color,
      'label_background_color': this.state.widgetInfo.acf.label_background_color,
      'label_text_color': this.state.widgetInfo.acf.label_text_color,
      'title_color': this.state.widgetInfo.acf.title_color,
      'decription_color': this.state.widgetInfo.acf.decription_color
    }

    Object.keys(currentState).forEach((color) => {
      currentState[color].value = colors[color];
    });

    this.setState({
      colors: currentState
    });
  }

  processMessageList(stateString, returnArray) {
    // const currentState = this.state.widgetInfo.acf[stateString + '_items'];
    const currentState = this.state.widgetInfo.acf[stateString + '_items'];

    if(currentState !== undefined && currentState !== null && currentState !== false) {
      const newState = currentState.map((item) => {
        return item.guid;
      });

      if(returnArray) {
        return newState;
      } else {
        this.setState({
          [stateString]: newState
        });
      }
    }
  }

  getFeeds() {
    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/get-feeds', {}, {
      'headers': GetAuthHeader()
    })
      .then( response => {
        if(this.unmounted) return;  

        this.setState({
          'feeds': response.data.data.feeds,
          'loading': false
        });

      })
      .catch( error => {
        this.setState({
          'loading': false
        })
      });
  }

  getMessages(feeds) {
    const data = {
      'feeds': feeds
    };

    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/load-messages', data, {
      'headers': GetAuthHeader()
    })
      .then( response => {
        if(this.unmounted) return;  

        let messages = this.mergeFeeds(response.data.data.feeds);
        messages = this.sortFeeds(messages);

        this.setState({
          'messages': messages,
          'messagesLoading': false
        }, () => {
          this.processMessageList('hidden', false);
          this.processMessageList('sticky', false);
        });
      })
      .catch( error => {
        this.setState({
          'messagesLoading': false
        })
      });
  }

  mergeFeeds(feeds) {
    let singleFeed = [];

    if(feeds === false) {
      return [];
    }

    feeds.forEach((feed) => {
      const feedChannel = feed.data.channel;

      if(feedChannel.item !== undefined) {
        feedChannel.item.forEach((singleItem) => {
          singleItem.brandName = feed.feed_title;
        });

        const item = feedChannel.item;

        this.pushArray(singleFeed, item);
      }
    });

    return singleFeed;
  }

  pushArray(arr, arr2) {
      arr.push.apply(arr, arr2);
  }

  sortFeeds(feeds) {
    feeds.sort(function(a, b){
      return new Date(b.pubDate) - new Date(a.pubDate);
    });

    return feeds;
  }

  renderMessageList(stateString) {
    if(this.state.messages === undefined || this.state.messages === null || this.state.messages.length < 1) {
      return (
        <p className="m-0 px-2 py-5">Geen feeds met inhoud geselecteerd</p>
      );
    }

    return this.state.messages.map((message, i) => {
      return (
        <div key={i}>
          <div className="custom-control custom-checkbox mb-1">
            <input
              className="custom-control-input"
              id={`${stateString}_${message.guid}`}
              type="checkbox"
              onChange={this.toggleMessage.bind(this, stateString, message.guid)}
              checked={this.state[stateString].indexOf(message.guid) > -1}
            />
            <label className="custom-control-label" htmlFor={`${stateString}_${message.guid}`}>
              {message.title}
            </label>
          </div>
        </div>
      );
    });
  }

  toggleMessage(stateString, guid) {
    let current = this.state[stateString];

    if(current.indexOf(guid) > -1) {
      current.splice(current.indexOf(guid), 1);
    } else {
      current.push(guid);
    }

    this.setState({
      [stateString]: current
    }, () => {
      this.watchChanges();
    });
  }

  changeTitle(e) {
    const element = e.target;
    const value = element.value;

    this.setState({
      title: value
    });
  }

  feedRow() {
    const rows = this.state.feedInput;

    return rows.map((row, i) => {
      return (
        <tr key={i}>
          <td>
            <Form>
              <FormGroup className="mb-0">
                <Input id={`title-${i}`} type="select" value={row.title} onChange={this.updateSelect.bind(this, 'title', i)}>
                  <option value="none">Selecteer titel</option>
                  {this.renderOptions.bind(this, 'title', false)()}
                </Input>
              </FormGroup>
            </Form>
          </td>
          <td>
            <Form>
              <FormGroup className="mb-0">
                <Input id={`feed-${i}`} type="select" value={row.feed} onChange={this.updateSelect.bind(this, 'feed', i)}>
                  <option value="none">{(row.title === 'none' ? 'Selecteer eerst een titel' : 'Selecteer feed')}</option>
                  {this.renderOptions.bind(this, 'feed', row.title)()}
                </Input>
              </FormGroup>
            </Form>
          </td>
          <td>
            {(row.title !== 'none' && row.feed !== 'none' ?
              <i className="ni ni-fat-remove text-lg my-2 detail__remove-feed" onClick={this.removeFeed.bind(this, i)}></i>
            :
              null
            )}
          </td>
        </tr>
      )
    });
  }

  removeFeed(item) {
    let input = this.state.feedInput;

    input[item].title = 'none';
    input[item].feed = 'none';

    this.setState({
      'feedInput': input
    }, () => {
      this.afterFeedChange(this.state.feedInput);
      this.watchChanges();
    });
  }

  renderOptions(type, title) {
    if(this.state.feeds === undefined || this.state.feeds === null || this.state.feeds.length === 0) {
      return (
        <option>Laden...</option>
      );
    } else {

      if(type === 'title') {
        return this.state.feeds.map((item, i) => {
          return (
            <option key={i} value={item.title}>{TransformTitle(item.title)}</option>
          ); 
        });
      }

      if(type === 'feed') {
        return this.state.feeds.map((item) => {
          if(item.title === title) {

            return item.feeds.map((feed, i) => {
              return (
                <option key={i} value={feed.url}>{feed.name}</option>
              ); 
            });

          }
        });
      }

    }    
  }

  updateSelect(key, row, e) {
    const element = e.target;
    const value = element.value;

    const prevInput = this.state.feedInput;

    prevInput[row][key] = value;

    this.setState({
      'feedInput': prevInput
    }, () => {
      this.afterFeedChange(this.state.feedInput);
      this.watchChanges();
    });
  }

  afterFeedChange(afterChange) {
    this.setState({
      'messagesLoading': true
    });

    this.getMessages.bind(this, this.state.feedInput)();

    let hasEmptyRow = 0;
    let input = afterChange;

    input.map((row) => {
      if(row.title === 'none'|| row.feed === 'none') {
        hasEmptyRow++;
      }
    });

    if(hasEmptyRow < 1) {
      input.push({
        'title': 'none',
        'feed': 'none'
      });

      this.setState({
        'feedInput': input
      });
    } else if(hasEmptyRow > 1) {
      let itemToSplice = false;

      input.map((row, i) => {
        if(row.title === 'none') {
          itemToSplice = i;
        }
      });

      input.splice(itemToSplice, 1);

      this.setState({
        'feedInput': input
      });
    }
  }

  toggleModal(state) {
    this.setState({
      [state]: !this.state[state]
    });
  };

  exportWidget() {
    this.toggleModal('exportModal');

    const codeToExport = `
      <div
        data-dpg-rss-widget="${this.props.match.params.id}"
        data-dpg-rss-url="${this.props.generic.endpoint}"
        class="dpg-rss-feed"
      ></div>
      <script src="${this.props.generic.endpoint}loadWidget.js"></script>
      <link rel="stylesheet" type="text/css" href="${this.props.generic.endpoint}loadWidget.css">
    `;

    this.setState({
      'exportCode': codeToExport
    });    
  }

  saveWidget(exportWidget) {
    this.setState({
      'loading': true,
      'unsavedChanges': false,
      'titleError': false,
      'amountError': false
    });

    if(exportWidget) {
      this.exportWidget();
    }

    if(this.state.title === null || this.state.title === undefined || this.state.title.length < 1) {
      this.setState({
        'titleError': 'Kies een titel voor deze widget',
        'loading': false
      });

      return false;
    }

    if(this.state.title.length < 5) {
      this.setState({
        'titleError': 'Kies een titel langer dan 5 karakters.',
        'loading': false
      });

      return false;
    }

    if(!isNaN(this.state.amount * 1) && ((this.state.amount * 1) < 1)) {
      this.setState({
        'amountError': 'Kies een geldig maximaal aantal berichten.',
        'loading': false
      });

      return false;
    }

    const data = {
      'data': {
        'id': this.props.match.params.id,
        'feeds': this.state.feedInput,
        'maximum_item_count': this.state.amount,
        'hide_item_description': this.state.hideText,
        'show_title': this.state.showTitle,
        'background_color': this.state.colors.background_color.value,
        'border_color': this.state.colors.border_color.value,
        'date_color': this.state.colors.date_color.value,
        'label_background_color': this.state.colors.label_background_color.value,
        'label_text_color': this.state.colors.label_text_color.value,
        'title_color': this.state.colors.title_color.value,
        'decription_color': this.state.colors.decription_color.value,
        'sticky_items': this.state.sticky,
        'hidden_items': this.state.hidden,
        'title': this.state.title
      }
    };

    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/save-widget', data, {
      'headers': GetAuthHeader()
    })
      .then( response => {
        if(this.unmounted) return;

         this.getWidget.bind(this)(this.props.match.params.id, false);

         this.refs.previewWidget.runWidgetPreview();
      })
      .catch( error => {
        this.setState({
          'loading': false
        })
      });
  }

  changeColor(name, e) {
    const element = e.target;
    const value = element.value;

    const colors = this.state.colors;

    colors[name].value = value;

    this.setState({
      colors: colors
    });
  }

  changeColorViaPicker(name, color) {
    const colors = this.state.colors;

    colors[name].value = color.hex;

    this.setState({
      colors: colors
    }, () => {
      this.watchChanges();
    });
  }

  toggleEnabled(e) {
    const isEnabled = e.target.checked;
    const newValue = (isEnabled ? 'y' : 'n');

    this.setState({
      'loading': true
    });

    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/toggle-enabled-state', {
        'enabled': newValue,
        'id': this.props.match.params.id
      }, {
        'headers': GetAuthHeader()
      })
        .then( response => {
            if(this.unmounted) return;  

            this.setState({
              'loading': false,
              'enabled': response.data.data.enabled === 'y'
            }, () => {
              this.refs.previewWidget.runWidgetPreview();
            });
          })
          .catch( error => {
            this.setState({
              'loading': false
            }, () => {
              this.props.history.push('/auth/login');
            })
          });
  }

  renderColors() {
    const colors = this.state.colors;

    return Object.keys(colors).map((color, i) => {
      return (
        <FormGroup key={i} className="detail__color-picker">
          <SketchPicker
            color={this.state.colors[color].value}
            name={color}
            onChange={this.changeColorViaPicker.bind(this, color)}
            className={(this.state.activePicker === color ? 'active' : '')}
          />

          <Label className="text-sm text-bold">{this.state.colors[color].label}</Label>
          <InputGroup className="detail__color-picker-input-group" onClick={this.toggleColorPicker.bind(this, color)}>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <div
                  style={{'backgroundColor': this.state.colors[color].value}}
                  className="detail__color-picker-preview"
                ></div>
              </InputGroupText>
            </InputGroupAddon>
            <Input
              value={this.state.colors[color].value}
              onChange={this.changeColor.bind(this, color)}
              className="detail__color-picker-input"
              readOnly />
            <InputGroupAddon addonType="append">
              <InputGroupText><i className={(this.state.activePicker === color ? 'ni ni-fat-remove' : 'ni ni-palette')}></i></InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </FormGroup>
      );
    });
  }

  toggleColorPicker(name) {
    this.setState({
      'activePicker': (this.state.activePicker === name ? '' : name)
    });
  }

  changeAmount(e) {
    const element = e.target;
    const value = element.value;

    this.setState({
      amount: value
    }, () => {
      this.watchChanges();
    });
  }

  watchChanges() {
    this.setState({
      'unsavedChanges': (
        JSON.stringify(this.processFeeds(this.state.widgetInfo.acf.feeds, true)) === JSON.stringify(this.state.feedInput) &&
        this.state.widgetInfo.acf.maximum_item_count === this.state.amount &&
        this.state.widgetInfo.acf.background_color === this.state.colors.background_color.value &&
        this.state.widgetInfo.acf.border_color === this.state.colors.border_color.value &&
        this.state.widgetInfo.acf.date_color === this.state.colors.date_color.value &&
        this.state.widgetInfo.acf.label_background_color === this.state.colors.label_background_color.value &&
        this.state.widgetInfo.acf.label_text_color === this.state.colors.label_text_color.value &&
        this.state.widgetInfo.acf.title_color === this.state.colors.title_color.value &&
        this.state.widgetInfo.acf.decription_color === this.state.colors.decription_color.value &&
        JSON.stringify(this.processMessageList('sticky', true)) === JSON.stringify(this.state.sticky) &&
        JSON.stringify(this.processMessageList('hidden', true)) === JSON.stringify(this.state.hidden)
      ?
        false
      :
        true
      )
    });
  }

  toggleCheckbox(checkbox) {
    this.setState({
      [checkbox]: !this.state[checkbox]
    });
  }

  removeWidget(item) {
    const idArray = [];

    idArray.push(this.props.match.params.id);

    this.setState({
      'loading': true
    });

    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/remove-widgets', {
      'items': idArray
    }, {
      'headers': GetAuthHeader()
    })
      .then( response => {
        if(this.unmounted) return;  

        this.props.history.push('/admin/overview');
      })
      .catch( error => {
        this.setState({
          'loading': false
        }, () => {
          this.props.history.push('/auth/login');
        })
      });
  }

  render() {
    return (
      <>
        <div className={`detail__background ${(!this.state.addNew && !this.state.loading ? 'detail__background--colored' : '')}`}></div>

        <div className="detail__content">
          <AdminHeader
            history={this.props.history}
            items={[
              {
                'name': 'Overzicht',
                'path': '/admin/overview'
              },
              {
                'name': (this.state.addNew ? 'Nieuwe widget' : (this.state.loading || this.state.widgetInfo === undefined || this.state.widgetInfo.post === undefined ? ' Laden...' : this.state.widgetInfo.post.post_title)),
                'path': false
              }
            ]}
          />

          <Container className="mt-2">
            <Row className="justify-content-center">
              <Col md="12">

                <Loader active={this.state.loading} className={(this.state.loading ? 'py-8' : '')}>
                  {(this.state.addNew ?
                    <Card>
                      <CardHeader>
                        <h2 className="mb-0">Nieuwe widget aanmaken</h2>
                      </CardHeader>
                      <CardBody>
                        <p>Hoe wil je de nieuwe widget noemen?</p>

                        <Row>
                          <Col md="8">

                            <Form onSubmit={this.addWidget.bind(this)}>
                              <FormGroup className="d-flex flex-column flex-md-row">
                                <Input
                                  id="widgetname"
                                  type="text"
                                  name="'widgetname"
                                />
                                <Button
                                  aria-pressed={true}
                                  className="active"
                                  color="dark"
                                  role="button"
                                  size="md"
                                  className="mt-3 mt-md-0 ml-md-3"
                                >
                                  Widget aanmaken
                                </Button>
                              </FormGroup>
                              {(this.state.addNewError !== false &&
                                <p className="text-sm text-danger mb-1 mt--2">
                                  {this.state.addNewError}
                                </p>
                              )}
                            </Form>

                          </Col>
                        </Row>

                      </CardBody>
                    </Card>
                  :
                    <>
                      <Row>
                        <Col md="6">
                          <div className="detail__column detail__column--left">
                            <div className="mb-4 mb-md-0">
                              {(this.state.unsavedChanges &&
                                <Alert color="warning">
                                  <strong>Let op!</strong> Je hebt de configuratie van deze widget aangepast. Sla de widget op om de bijwerkte preview te zien.
                                </Alert>
                              )}
                              <Preview
                                id={this.props.match.params.id}
                                ref="previewWidget"
                                url={this.props.generic.endpoint}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="detail__column detail__column--right">
                          
                            <Card>
                              <CardHeader className="py-3">
                                <h4 className="mb-0">RSS feeds</h4>
                              </CardHeader>
                              <Table className="align-items-center table-flush detail__table" responsive>
                                <thead className="thead-light">
                                  <tr>
                                    <th>Titel</th>
                                    <th>Feed</th>
                                    <th/>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.feedRow.bind(this)()}
                                </tbody>
                              </Table>
                            </Card>

                            <Card>
                              <CardHeader className="py-3">
                                <h4 className="mb-0">Kleuren widget</h4>
                              </CardHeader>
                              <CardBody>
                                {this.renderColors.bind(this)()}
                              </CardBody>
                            </Card>

                            <Card>
                              <CardHeader className="py-3">
                                <h4 className="mb-0">Feed content</h4>
                              </CardHeader>
                              <CardBody>
                                <Label className="text-sm text-bold mt--2 d-block">Titel widget</Label>
                                <Input type="text" value={this.state.title} onChange={this.changeTitle.bind(this)} className="mb-3" />

                                {(this.state.titleError &&
                                  <p class="text-danger text-sm mt--2">{this.state.titleError}</p>
                                )}

                                <div className="custom-control custom-checkbox mb-1">
                                  <input
                                    className="custom-control-input"
                                    id="show_title"
                                    type="checkbox"
                                    onChange={this.toggleCheckbox.bind(this, 'showTitle')}
                                    checked={this.state.showTitle}
                                  />
                                  <label className="custom-control-label" htmlFor="show_title">
                                    Titel boven widget tonen
                                  </label>
                                </div>

                                <div className="custom-control custom-checkbox mb-1">
                                  <input
                                    className="custom-control-input"
                                    id="hide_item_description"
                                    type="checkbox"
                                    onChange={this.toggleCheckbox.bind(this, 'hideText')}
                                    checked={this.state.hideText}
                                  />
                                  <label className="custom-control-label" htmlFor="hide_item_description">
                                    Verberg beschrijving bij berichten
                                  </label>
                                </div>
                              </CardBody>
                            </Card>

                            <Card>
                              <CardHeader className="py-3">
                                <h4 className="mb-0">Maximaal aantal berichten</h4>
                              </CardHeader>
                              <CardBody>
                                <Input
                                  type="number"
                                  value={this.state.amount}
                                  onChange={this.changeAmount.bind(this)}
                                  />

                                  {(this.state.amountError !== false &&
                                    <p className="text-sm text-danger mb-1 mt-2">
                                      {this.state.amountError}
                                    </p>
                                  )}
                              </CardBody>
                            </Card>

                            <Card>
                              <CardHeader className="py-3">
                                <h4 className="mb-0">Verborgen berichten</h4>
                              </CardHeader>
                              <CardBody>
                                <div className="detail__checkbox-container">
                                  <Loader active={this.state.messagesLoading} className={(this.state.loading ? 'py-0' : '')}>
                                    {this.renderMessageList('hidden')}
                                  </Loader>
                                </div>
                              </CardBody>
                            </Card>

                            <Card>
                              <CardHeader className="py-3">
                                <h4 className="mb-0">Sticky berichten</h4>
                              </CardHeader>
                              <CardBody>
                                <div className="detail__checkbox-container">
                                  <Loader active={this.state.messagesLoading} className={(this.state.loading ? 'py-0' : '')}>
                                    {this.renderMessageList('sticky')}
                                  </Loader>
                                </div>
                              </CardBody>
                            </Card>

                            <Card>
                              <CardHeader className="py-3">
                                <h4 className="mb-0">Widget verbergen of verwijderen</h4>
                              </CardHeader>
                              <CardBody>
                                <Row>
                                  <Col md="6">
                                    <label className="text-sm text-bold">Widget actief?</label>
                                    <div className="d-flex text-muted my-2 mb-4 mb-md-2">
                                      <label className="custom-toggle">
                                        <input
                                          type="checkbox"
                                          onChange={this.toggleEnabled.bind(this)}
                                          checked={this.state.enabled}
                                        />
                                        <span
                                          className="custom-toggle-slider rounded-circle"
                                          data-label-off="Nee"
                                          data-label-on="Ja"
                                          
                                        />
                                    </label>
                                    </div>
                                  </Col>
                                  <Col md="6">
                                    <label className="text-sm text-bold">Widget verwijderen</label>
                                    <Button color="danger" size="sm" type="button" onClick={this.removeWidget.bind(this)} className="my-1" style={{'overflow': 'hidden', 'display': 'block'}}>
                                      Verwijderen
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>

                          </div>
                        </Col>
                      </Row> 
                    </>
                  )}
                </Loader>

              </Col>
            </Row>
          </Container>
        </div>

        <div className="detail__save-container">
          <Container>
            <Row className="d-flex justify-content-end">
              <Col xs="auto">
                <Button color="white" size="md" type="button" className="btn-icon btn-3" onClick={this.saveWidget.bind(this, true)} disabled={this.state.loading}>
                  Opslaan & exporteren
                </Button>
              </Col>
              <Col xs="auto">
                <Button color="dark" size="md" type="button" className="btn-icon btn-3" onClick={this.saveWidget.bind(this, false)} disabled={this.state.loading}>
                  Opslaan
                </Button>
              </Col>
            </Row>
          </Container>
        </div>

        <Modal
          className="modal-dialog-centered"
          isOpen={this.state.exportModal}
        >
          <div className="modal-header">
            <h5 className="modal-title">
              Widget exporteren
            </h5>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("exportModal")}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            Gebruik onderstaande HTML code om deze widget op uw website weer te geven.

            <code className="d-block border p-3 mt-3 mb--3">
              {this.state.exportCode}
            </code>
          </div>
          <div className="modal-footer">
            <Button
              color="secondary"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal('exportModal')}
            >
              Sluiten
            </Button>
          </div>
        </Modal>

      </>
    );
  }
}

export default Detail;
